(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size' || this.getAttribute('data-sticky-type') === 'attachment';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
(() => {
  const SOURCE_PAGE_SIZE = 50;
  let revision = 0;
  const activeRequests = new WeakMap();

  const parsePage = (html) => {
    const parsedDocument = new DOMParser().parseFromString(html, 'text/html');
    const metadata = parsedDocument.querySelector('[data-runax-source-meta]');
    return {
      count: Number(metadata?.dataset.count || 0),
      pages: Number(metadata?.dataset.pages || 1),
      products: Array.from(parsedDocument.querySelectorAll('[data-runax-source-product]'))
    };
  };

  const buildSourceUrl = (page, view, available) => {
    const url = new URL(window.location.href);
    url.searchParams.set('view', view);
    url.searchParams.set('page', String(page));

    if (available !== null) {
      url.searchParams.delete('filter.v.availability');
      url.searchParams.append('filter.v.availability', available ? '1' : '0');
    }

    return url;
  };

  const fetchSourcePage = async (page, view, available, signal) => {
    const response = await fetch(buildSourceUrl(page, view, available), {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      signal
    });
    if (!response.ok) throw new Error('Unable to load collection products');
    return parsePage(await response.text());
  };

  const fetchSlice = async (offset, length, view, available, signal, cachedFirstPage) => {
    if (length <= 0) return [];

    let sourcePage = Math.floor(offset / SOURCE_PAGE_SIZE) + 1;
    let pageOffset = offset % SOURCE_PAGE_SIZE;
    const products = [];

    while (products.length < length) {
      const result = sourcePage === 1 && cachedFirstPage
        ? cachedFirstPage
        : await fetchSourcePage(sourcePage, view, available, signal);

      products.push(...result.products.slice(pageOffset));
      pageOffset = 0;
      if (sourcePage >= result.pages) break;
      sourcePage += 1;
    }

    return products.slice(0, length);
  };

  const fetchAllPages = async (firstPage, view, available, signal) => {
    if (firstPage.pages <= 1) return firstPage.products;

    const remainingPages = await Promise.all(
      Array.from({ length: firstPage.pages - 1 }, (_, index) =>
        fetchSourcePage(index + 2, view, available, signal)
      )
    );

    return firstPage.products.concat(...remainingPages.map((page) => page.products));
  };

  const initializeGrid = async (root) => {
    const grid = root.querySelector('#product-grid');
    if (!grid) return;

    const signature = window.location.pathname + window.location.search;
    if (grid.dataset.runaxAvailabilityOrder === signature) return;

    const previousRequest = activeRequests.get(root);
    if (previousRequest) {
      if (previousRequest.signature === signature) return;
      previousRequest.controller.abort();
    }

    const requestController = new AbortController();
    const activeRequest = { controller: requestController, signature };
    activeRequests.set(root, activeRequest);

    const pageSize = Number(root.dataset.pageSize || 24);
    const sourceView = root.dataset.sourceView || 'runax-source';
    const url = new URL(window.location.href);
    const currentPage = Math.max(1, Number(url.searchParams.get('page') || 1));
    const start = (currentPage - 1) * pageSize;
    const end = start + pageSize;
    const availabilityFilters = url.searchParams.getAll('filter.v.availability');
    const requestRevision = ++revision;
    root.setAttribute('aria-busy', 'true');

    try {
      let orderedProducts = [];

      if (availabilityFilters.length === 0) {
        const firstAvailablePage = await fetchSourcePage(
          1,
          sourceView,
          true,
          requestController.signal
        );
        const availableCount = firstAvailablePage.count;
        const availableStart = Math.min(start, availableCount);
        const availableEnd = Math.min(end, availableCount);

        orderedProducts.push(...await fetchSlice(
          availableStart,
          availableEnd - availableStart,
          sourceView,
          true,
          requestController.signal,
          firstAvailablePage
        ));

        if (orderedProducts.length < pageSize) {
          const firstSoldOutPage = await fetchSourcePage(
            1,
            sourceView,
            false,
            requestController.signal
          );
          const soldOutProducts = (await fetchAllPages(
            firstSoldOutPage,
            sourceView,
            false,
            requestController.signal
          )).filter((product) => product.dataset.available === 'false');
          const soldOutStart = Math.max(0, start - availableCount);

          orderedProducts.push(...soldOutProducts.slice(
            soldOutStart,
            soldOutStart + pageSize - orderedProducts.length
          ));
        }
      } else if (
        availabilityFilters.includes('1') &&
        !availabilityFilters.includes('0')
      ) {
        orderedProducts = await fetchSlice(
          start,
          pageSize,
          sourceView,
          true,
          requestController.signal
        );
      } else {
        const firstFilteredPage = await fetchSourcePage(
          1,
          sourceView,
          null,
          requestController.signal
        );
        const filteredProducts = await fetchAllPages(
          firstFilteredPage,
          sourceView,
          null,
          requestController.signal
        );
        const availableProducts = filteredProducts.filter(
          (product) => product.dataset.available === 'true'
        );
        const soldOutProducts = filteredProducts.filter(
          (product) => product.dataset.available === 'false'
        );

        orderedProducts = availableProducts.concat(soldOutProducts).slice(start, end);
      }

      if (requestRevision !== revision || !document.contains(root)) return;

      const fragment = document.createDocumentFragment();
      orderedProducts.forEach((product, index) => {
        const importedProduct = document.importNode(product, true);
        importedProduct.style.setProperty('--animation-order', String(index + 1));
        fragment.appendChild(importedProduct);
      });

      grid.replaceChildren(fragment);
      grid.dataset.runaxAvailabilityOrder = signature;
      document.dispatchEvent(new CustomEvent('runax:collection-reordered', {
        detail: {
          page: currentPage,
          shown: orderedProducts.length
        }
      }));
    } catch (error) {
      if (error.name !== 'AbortError') root.dataset.runaxAvailabilityError = 'true';
    } finally {
      if (activeRequests.get(root) === activeRequest) {
        activeRequests.delete(root);
        root.removeAttribute('aria-busy');
      }
    }
  };

  const initializeAll = () => {
    document.querySelectorAll('[data-runax-availability-grid]').forEach(initializeGrid);
  };

  const observer = new MutationObserver(() => window.requestAnimationFrame(initializeAll));
  observer.observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
  } else {
    initializeAll();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
